import script from "./SimpleCheckbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./SimpleCheckbox.vue?vue&type=script&lang=ts&setup=true"

import "./SimpleCheckbox.vue?vue&type=style&index=0&id=34999422&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34999422"]])

export default __exports__